export default __webpack_public_path__ + "static/Ohio-205fee68ca4e9bf3bc1141ed2b3cd18a.webp";